/**
 * @generated SignedSource<<b24243cff4c2f12e2130a3c5269b047b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type UserNodeIdTypeEnum = "DATABASE_ID" | "EMAIL" | "ID" | "SLUG" | "URI" | "USERNAME";
export type User_Management_Single_Query$variables = {
  idType?: UserNodeIdTypeEnum | null | undefined;
  userId: string;
};
export type User_Management_Single_Query$data = {
  readonly user: {
    readonly avatar: {
      readonly url: string | null | undefined;
    } | null | undefined;
    readonly email: string | null | undefined;
    readonly firstName: string | null | undefined;
    readonly forms: {
      readonly nodes: ReadonlyArray<{
        readonly id: string;
      }>;
    } | null | undefined;
    readonly id: string;
    readonly lastName: string | null | undefined;
    readonly meta: {
      readonly jobRole: string | null | undefined;
      readonly profileArticleLinks: ReadonlyArray<{
        readonly iconName: string | null | undefined;
        readonly name: string | null | undefined;
        readonly url: string | null | undefined;
      } | null | undefined> | null | undefined;
      readonly profileImage: {
        readonly id: string;
        readonly mediaDetails: {
          readonly sizes: ReadonlyArray<{
            readonly name: string | null | undefined;
            readonly sourceUrl: string | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
        readonly mediaItemUrl: string | null | undefined;
      } | null | undefined;
      readonly profileSocialLinks: ReadonlyArray<{
        readonly name: string | null | undefined;
        readonly url: string | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
    readonly name: string | null | undefined;
    readonly nicename: string | null | undefined;
    readonly registeredDate: string | null | undefined;
    readonly role: string | null | undefined;
    readonly slug: string | null | undefined;
    readonly username: string | null | undefined;
    readonly znglists: {
      readonly nodes: ReadonlyArray<{
        readonly id: string;
      }>;
    } | null | undefined;
    readonly znglyVideos: {
      readonly nodes: ReadonlyArray<{
        readonly id: string;
      }>;
    } | null | undefined;
  } | null | undefined;
};
export type User_Management_Single_Query = {
  response: User_Management_Single_Query$data;
  variables: User_Management_Single_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": "ID",
  "kind": "LocalArgument",
  "name": "idType"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userId"
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v5 = {
  "kind": "Literal",
  "name": "first",
  "value": 1
},
v6 = [
  (v5/*: any*/),
  {
    "kind": "Literal",
    "name": "where",
    "value": {
      "stati": [
        "PUBLISH",
        "HIDDEN"
      ]
    }
  }
],
v7 = [
  (v2/*: any*/)
],
v8 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "userId"
      },
      {
        "kind": "Variable",
        "name": "idType",
        "variableName": "idType"
      }
    ],
    "concreteType": "User",
    "kind": "LinkedField",
    "name": "user",
    "plural": false,
    "selections": [
      (v2/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "username",
        "storageKey": null
      },
      (v3/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "role",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "slug",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "email",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "nicename",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "firstName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "lastName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "registeredDate",
        "storageKey": null
      },
      {
        "alias": null,
        "args": [
          {
            "kind": "Literal",
            "name": "size",
            "value": 10
          }
        ],
        "concreteType": "Avatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
          (v4/*: any*/)
        ],
        "storageKey": "avatar(size:10)"
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "User_Meta",
        "kind": "LinkedField",
        "name": "meta",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "jobRole",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MediaItem",
            "kind": "LinkedField",
            "name": "profileImage",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "mediaItemUrl",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "MediaDetails",
                "kind": "LinkedField",
                "name": "mediaDetails",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MediaSize",
                    "kind": "LinkedField",
                    "name": "sizes",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "sourceUrl",
                        "storageKey": null
                      },
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "User_Meta_profileSocialLinks",
            "kind": "LinkedField",
            "name": "profileSocialLinks",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "User_Meta_profileArticleLinks",
            "kind": "LinkedField",
            "name": "profileArticleLinks",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "iconName",
                "storageKey": null
              },
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v6/*: any*/),
        "concreteType": "UserToZnglyVideoConnection",
        "kind": "LinkedField",
        "name": "znglyVideos",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ZnglyVideo",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": (v7/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": "znglyVideos(first:1,where:{\"stati\":[\"PUBLISH\",\"HIDDEN\"]})"
      },
      {
        "alias": null,
        "args": [
          (v5/*: any*/)
        ],
        "concreteType": "UserToFormConnection",
        "kind": "LinkedField",
        "name": "forms",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Form",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": (v7/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": "forms(first:1)"
      },
      {
        "alias": null,
        "args": (v6/*: any*/),
        "concreteType": "UserToZnglistConnection",
        "kind": "LinkedField",
        "name": "znglists",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Znglist",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": (v7/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": "znglists(first:1,where:{\"stati\":[\"PUBLISH\",\"HIDDEN\"]})"
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "User_Management_Single_Query",
    "selections": (v8/*: any*/),
    "type": "RootQuery",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "User_Management_Single_Query",
    "selections": (v8/*: any*/)
  },
  "params": {
    "cacheID": "26e256bb0c1955fe7d8be097a928f2d6",
    "id": null,
    "metadata": {},
    "name": "User_Management_Single_Query",
    "operationKind": "query",
    "text": "query User_Management_Single_Query(\n  $userId: ID!\n  $idType: UserNodeIdTypeEnum = ID\n) {\n  user(id: $userId, idType: $idType) {\n    id\n    username\n    name\n    role\n    slug\n    email\n    nicename\n    firstName\n    lastName\n    registeredDate\n    avatar(size: 10) {\n      url\n    }\n    meta {\n      jobRole\n      profileImage {\n        id\n        mediaItemUrl\n        mediaDetails {\n          sizes {\n            sourceUrl\n            name\n          }\n        }\n      }\n      profileSocialLinks {\n        name\n        url\n      }\n      profileArticleLinks {\n        name\n        iconName\n        url\n      }\n    }\n    znglyVideos(first: 1, where: {stati: [PUBLISH, HIDDEN]}) {\n      nodes {\n        id\n      }\n    }\n    forms(first: 1) {\n      nodes {\n        id\n      }\n    }\n    znglists(first: 1, where: {stati: [PUBLISH, HIDDEN]}) {\n      nodes {\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "0f5618211000aa8d20b46f0ce6d621f4";

export default node;
